import React from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import HeroImg from '../Components/HeroImg'
import Form  from '../Components/Form'


const Contact = () => {
  return (
    <div>
      <Navbar/>
      <HeroImg heading="CONTACT." text="Lets have a chat"/>
      <Form/>
      <Footer/>
    </div>
  )
}

export default Contact